// extracted by mini-css-extract-plugin
export default {"imageGalleryWrapper":"Gallery_imageGalleryWrapper__RLlcF"};